import { EventEmitter, Injectable } from '@angular/core';
import { AssetGrouping } from '@app/_models/assetGrouping';
import { Asset } from '@app/_models/_DTOs/asset';
import { Employee } from '@app/_models/_DTOs/employee';

@Injectable({ providedIn: 'root' })
export class SelectionService {
    constructor() {
    }

    selectionChange: EventEmitter<boolean> = new EventEmitter();
    getSelectionChangeEmitter() : EventEmitter<boolean> {
        return this.selectionChange;
    }

    public selectedAssets: Asset[] = [];

    public selectedEmployeeAssets: AssetGrouping<Employee>[];

    public clearSelection() {
        this.selectedAssets = [];
        this.selectionChange.emit();
    }

    public addToSelection(asset: Asset, emmitChange?: boolean) {
        if (!this.selectedAssets.some(x => x.id == asset.id)) {
            this.selectedAssets.push(asset);
            if(emmitChange){
                this.selectionChange.emit();
            }
        }
    }

    public addManyToSelection(assets: Asset[], emmitChange?: boolean) {
        for (let asset of assets) {
            this.addToSelection(asset, emmitChange);
        }
    }

    public removeFromSelection(asset: Asset, emmitChange?: boolean) {
        let assetInSelectedAssets = this.selectedAssets.find(x => x.id == asset.id);
        const index = this.selectedAssets.indexOf(assetInSelectedAssets);
        if (index > -1) {
            this.selectedAssets.splice(index, 1);
            if(emmitChange){
                this.selectionChange.emit();
            }
        }
    }

    public removeManyFromSelection(assets: Asset[], emmitChange?: boolean) {
        for (let asset of assets) {
            this.removeFromSelection(asset, emmitChange);
        }
    }
}